<template>
	<v-app>
		<v-navigation-drawer
			v-model="menuShow"
			:color="$vuetify.theme.dark ? '#1E1E1E' : 'primary'"
			app
			inset
			v-if="$store.getters.isLoggedIn && themeLoaded"
		>
			<v-avatar tile size="256" class="pa-5">
				<v-img contain :src="`./img/logo_blanco_${$store.getters.getNombreEmpresa}.png`" :key="theme"></v-img>
			</v-avatar>

			<v-tabs :background-color="$vuetify.theme.dark ? '' : 'primary'" vertical slider-size="5">
				<v-tab
					active-class="active-tab"
					style="height: 40px"
					class="rounded-r-pill mr-1"
					v-for="link in menu"
					:key="link.url"
					:to="link.url"
					v-if="!link.acceso || $root.acceso(link.acceso)"
				>
					<v-list-item-icon class="my-auto">
						<v-icon color="white" v-text="link.icon" />
					</v-list-item-icon>
					<v-list-item-content class="text-start white--text" style="font-size: 0.7rem">
						<div class="d-flex">
							{{ link.texto }}
							<small v-if="link.pruebas" class="align-start ml-2">PRUEBAS</small>
						</div>
					</v-list-item-content>
				</v-tab>
			</v-tabs>
			<template v-if="development" v-slot:append>
				<div class="d-flex align-end justify-center">
					<cambiar-entorno v-if="$root.acceso('VER_CONTRATOS')" />
				</div>
			</template>
		</v-navigation-drawer>

		<v-app-bar app v-if="$store.getters.isLoggedIn && themeLoaded">
			<v-btn @click="menuShow = !menuShow" icon>
				<v-icon v-text="'mdi-menu'" />
			</v-btn>
			<v-toolbar-title>{{ [portal, $store.getters.getNombreEmpresa.toUpperCase()].join(' ') }}</v-toolbar-title>
			<v-spacer />

			<v-btn icon @click="$vuetify.theme.dark = !$vuetify.theme.dark">
				<v-icon v-if="$vuetify.theme.dark">mdi-white-balance-sunny</v-icon>
				<v-icon v-else>mdi-weather-night</v-icon>
			</v-btn>

			<alertas-incidencias v-if="$root.acceso('VER_INCIDENCIAS')" :key="$route.fullPath"></alertas-incidencias>

			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn v-on="on" v-bind="attrs" small text @click.stop="logout" color="error">
						<span v-show="!$vuetify.breakpoint.mobile">Cerrar sesion</span>
						<v-icon right>mdi-logout</v-icon>
					</v-btn>
				</template>
				{{ $store.getters.getDecodedJwtEmpresa.nombre }}
			</v-tooltip>
		</v-app-bar>

		<v-main v-show="themeLoaded">
			<v-container fluid>
				<!-- <v-fade-transition mode="out-in"> -->
				<router-view :key="$route.fullPath + $store.getters.getEntorno" />
				<!-- </v-fade-transition> -->
			</v-container>
			<v-snackbar v-model="snack" timeout="4000" color="primary" type="error">
				{{
					msg
				}}
			</v-snackbar>

			<v-speed-dial
				bottom
				right
				:style="`${!$vuetify.breakpoint.smAndUp ? 'right: 56px' : ''}`"
				fixed
				v-if="(development || $store.getters.isAdmin) && themeLoaded"
			>
				<template v-slot:activator>
					<v-btn small color="primary" dark fab>
						<v-icon v-text="'mdi-palette'" />
					</v-btn>
				</template>
				<v-tooltip
					left
					:key="theme.name"
					:color="theme.light.secondary"
					v-for="theme in themes.filter(({ name }) => name != theme)"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							:key="theme.name"
							:color="theme.light.primary"
							@click="setTheme(theme.name)"
							dark
							fab
							small
							v-text="theme.name[0]"
							v-on="on"
							v-bind="attrs"
						/>
					</template>
					{{ theme.name.toUpperCase() }}
				</v-tooltip>
			</v-speed-dial>
		</v-main>
	</v-app>
</template>

<script>
// import axios from "redaxios";

export default {
	name: "App",
	components: {
		AlertasIncidencias: () => import("@/components/AlertasIncidencias.vue"),
		CambiarEntorno: () => import("@/components/CambiarEntorno.vue"),
	},
	metaInfo() {

		return {
			title: `${this.portal} | ${this.$store.getters.getNombreEmpresa}`,
			link: [
				{
					rel: "icon",
					href: `./img/fav_${this.$store.getters.getNombreEmpresa}.png`,
				},
			],
		};
	},
	data: () => ({
		menuShow: true,
		nombreAgente: "",
		themeLoaded: false,
		msg: "",
		snack: false,
		development: process.env.NODE_ENV == "development",
		theme: null,
		themes: [],
		portal: ((s = window.location.host.replaceAll(/www./g, "").split(".")[0]) => s && s[0].toUpperCase() + s.slice(1))(),
	}),
	computed: {
		isIdle() {
			return this.isAppIdle;
		},
		menu() {
			return [
				{ url: "/", texto: "Resumen", icon: "mdi-home" },
				{ url: "/sips", texto: "Sips", icon: "mdi-magnify", acceso: 'VER_CONTRATOS' },
				{
					url: "/contratos",
					texto: "Contratos",
					icon: "mdi-file-document-edit-outline", acceso: 'VER_CONTRATOS'
				},
				{ url: "/borradores", texto: "Borradores", icon: "mdi-eraser", acceso: 'VER_CONTRATOS' },
				{ url: "/clientes", texto: "Clientes", icon: "mdi-account-group", acceso: 'VER_CONTRATOS' },
				{ url: "/documentacion", texto: "Documentacion", icon: "mdi-folder", acceso: 'VER_CONTRATOS' },
				{
					url: "/incidencias",
					texto: "Incidencias",
					icon: "mdi-alert-circle",
					acceso: 'VER_INCIDENCIAS',
				},
				{
					url: "/autofacturas",
					texto: "Facturas colaboradores",
					icon: "mdi-archive-outline",
					acceso: 'VER_FACTURAS_COLABORADORES',
				},
				{
					url: "/colaboradores",
					texto: "Colaboradores",
					icon: "mdi-account-tie",
					acceso: 'VER_COLABORADORES',
				},
				{
					url: "/facturacion",
					texto: "Facturas clientes",
					icon: "mdi-currency-eur",
					acceso: 'VER_FACTURAS_CONTRATOS',
				},
				{
					url: "/impagados",
					texto: "Control impagados",
					icon: "mdi-currency-eur-off",
					acceso: 'CONTROL_IMPAGADOS',
				},
				{
					url: "/pruebas",
					texto: "Pruebas",
					icon: "mdi-test-tube",
					acceso: 'DEV',
				}
			];
		},
	},
	async beforeCreate() {
		let dominio =
			!/(\d{1,3}\.?){4}/.test(window.location.host) ?
				window.location.host.replaceAll(/www./g, "").split(".")[1] || 'alumbraenergia' :
				"alumbraenergia";

		await this.$store.dispatch("setNombreEmpresa", dominio);
		let { data: themes } = await axios({ url: "/themes.json" });
		let aux = {};
		Object.values(themes.themes).forEach(
			(t) => (aux[t.name] = t.light.primary)
		);
		await this.$store.dispatch("setColoresEmpresas", aux);
		this.themes = Object.values(themes.themes);
		let theme = themes.themes[dominio];
		this.theme = theme.name;
		Object.keys(theme.light).forEach((key) => {
			this.$vuetify.theme.themes.light[key] = theme.light[key];
			this.$vuetify.theme.themes.dark[key] = theme.light[key];
		});
		this.$vuetify.theme.themes.name = theme.name;
		this.themeLoaded = true;
	},
	methods: {
		setTheme(theme) {
			return new Promise(async (resolve) => {
				this.themeLoaded = false;
				if (typeof theme != "object")
					theme = this.themes.find(({ name }) => name == theme);
				this.theme = theme.name;
				Object.keys(theme.light).forEach((key) => {
					this.$vuetify.theme.themes.light[key] = theme.light[key];
					this.$vuetify.theme.themes.dark[key] = theme.light[key];

				});
				this.$vuetify.theme.themes.name = theme.name;
				this.themeLoaded = true;
				await this.$store.dispatch("setNombreEmpresa", theme.name);
				resolve();
			});
		},
		logout() {
			confirm("¿Estás seguro de que quieres cerrar sesión?")
				? this.$store
					.dispatch("logout")
					.then(() => this.$router.push({ name: "Login" }))
				: null;
		},
	},
	watch: {
		isIdle(newVal) {
			if (newVal && this.$store.getters.isLoggedIn) {
				this.$store.dispatch("logout");
				this.$router.push({
					name: "Login",
					query: {
						msg: "Se ha cerrado la sesión por inactividad",
						redirect: this.$route.fullPath,
					},
				});
			}
		},
	},
	mounted() {
		this.$root.$on("snack", (msg) => {
			this.snack = false;
			this.snack = true;
			this.msg = msg;
		});
	},
};
</script>

<style>
.border-l {
	border-left: 5px solid transparent;
}
.border-l-white {
	border-left: 5px solid white;
}
.active-tab {
	background-color: #00000036;
}

*::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}
*::-webkit-scrollbar-thumb {
	border-radius: 20px;
	background: var(--v-primary-base);
}
*.theme--dark ::-webkit-scrollbar-track {
	border-radius: 20px;
	background: #121212;
}
*::-webkit-scrollbar-track {
	border-radius: 20px;
	background: #bebebe;
}

.v-chip--active.theme--dark {
	border-style: unset !important;
}
</style>